export function initData(object) {
    object.data = {
        selectedIndex: -1,
        list: []
    };

    if (!object.$el.next('button').data('text')) {
        object.$el.next('button').data('text', object.$el.next('button').text().trim());
    }

    object.data.selectedIndex = object.$el[0].selectedIndex;
    object.data.list = object.$el.find('option').toArray().map((option, index) => {
        const $option = $(option);

        if (option.selected && !$option.attr('selected') && object.$el.val() != '') {
            $option.attr('selected', true);
        } else if (!option.selected && $option.attr('selected')) {
            $option.attr('selected', false);
        }

        return {
            index,
            disabled: $option.attr('disabled'),
            selected: $option.attr('selected'),
            value: $option.val(),
            text: $option.text(),
            link: $option.data('link'),
            value01: $option.attr('data-value01'),
            value02: $option.attr('data-value02'),
            tag: $option.attr('data-tag'),
            tagclass: $option.attr('data-tagclass'),
            bank: $option.data('bank'),
            img: $option.data('img'),
            group: $option.data('group'),
            el: $option[0],
            is_opbk_acnt: $option.attr('data-is_opbk_acnt'),
        };
    });
};

export function setSelectText(object) {
    if(object.data.selectedIndex === -1){
        return;
    }
    
    const accountCheck = object.defaults.item;

    object.$el.attr({tabindex: -1});

    const text = object.data.list[object.data.selectedIndex].text;
    const value01 = object.data.list[object.data.selectedIndex].el.dataset.value01;
    const sepa01 = object.data.list[object.data.selectedIndex].el.dataset.sepa01; // FETASK-1066 추가 
    const value02 = object.data.list[object.data.selectedIndex].el.dataset.value02;
    const tag = object.data.list[object.data.selectedIndex].el.dataset.tag; // FETASK-860 태그
    const tagclass = object.data.list[object.data.selectedIndex].el.dataset.tagclass; // FETASK-860 태그
    const bank = object.data.list[object.data.selectedIndex].el.dataset.bank;
    const group = object.data.list[object.data.selectedIndex].el.dataset.group;
    const img = object.data.list[object.data.selectedIndex].el.dataset.img;

    function checkTag(){
        const tagObj = `<span class="tag ${tagclass}"><span class="txt">${tag}</span></span>`, textWrap = object.$el.next('button').find('.select-txt-wrap');
        textWrap?.find('.tag').remove();
        if(tag != undefined && textWrap?.find('.tag').length < 1) {
            // textWrap?.find('.txt-value01').length > 0 ? textWrap?.find('.txt-value01').after(tagObj) : textWrap?.append(tagObj);

            // CHPFMTASK-2288 셀렉트박스건 태그 위치 수정
            if(textWrap?.find('.txt-value01').length > 0){
                textWrap?.find('.txt-value01').after(tagObj);
            }else if(textWrap?.find('.txt-value01').length < 1 && textWrap?.find('.txt-value02').length > 0){
                textWrap?.find('.txt-name').after(tagObj);
            }else{
                textWrap?.append(tagObj);
            }
        }
    }
    checkTag();
    
    // 기본
    if(group === 'bank' || group === 'stock'){
        object.$el.next('button').find('.txt-name').text(text);
        if(object.$el.next('button').find('.txt-name').prev('i').length <= 0){
            object.$el.next('button').find('.txt-name').before(`<i class="logo-bank089 w20" aria-hidden="true"></i>`);
        }
        object.$el.next('button').find('.txt-name').prev('i').removeClass().addClass(`${img} w20`);
    }
    else if (value01 === undefined) {
        if (object.$el.closest('[select-type="direct"]').length > 0 && object.$el.closest('.ui-input').attr('direct-selected') != undefined) { // 230808 직접입력 관련  수정
            object.$el.next('button').find('.txt-name').text(object.$el.closest('.ui-input').attr('direct-selected'));
        } else {
            object.$el.next('button').find('.txt-name').text(text);
        }
        
        object.$el.next('button').find('.txt-value01').text('').hide();
        if (value02 === undefined) {
            object.$el.next('button').find('.txt-value02').text('').hide();
        } else {
            object.$el.next('button').find('.txt-value02').text(value02).show();
        }
        // FETASK-860 태그
        // if (tag === undefined) {
        //     object.$el.next('button').find('.tag').hide();
        // }

        if (accountCheck === 'account' && object.$el.closest('.noline').length > 0) {
            object.$el.closest('.noline').addClass('noSelected');
        }
    }

    // 뱅크형
    else if (bank === undefined) {
        let val2Text;
        object.$el.next('button').find('.txt-name').text(`${text}`);
        if (accountCheck === 'account') {
            if (value01 === undefined || value01 === '') {
                object.$el.next('button').find('.txt-value01').text('').hide();
            } else {
                object.$el.next('button').find('.txt-value01').text(`(${value01})`);
                //object.$el.next('button').find('.txt-value01').text(` : ${value01}`);
                object.$el.next('button').find('.txt-value01').show();
                if (object.$el.closest('.noline').length > 0) {
                    object.$el.closest('.noline').removeClass('noSelected');
                }
            }
            if (object.$el.attr('data-type') != 'select-single') {  // 2023-06-13 |  FETASK-1066  | data-type="select-single" data-item="account" 일때 value02 값 필요없어서 추가됨 ( select-single (계좌목록)) 
                if (value02.toUpperCase() === 'L') {
                    val2Text = '조회중';
                } else if (value02.toUpperCase() === 'N') {
                    val2Text = '조회실패';
                } else if (value02.toUpperCase() === 'X') {
                    val2Text = '조회실패';
                } else if (value02.toUpperCase() === 'U') {
                    val2Text = '오픈뱅킹망 점검중';
                } else if (value02.toUpperCase() === 'T') {
                    val2Text = '해지계좌';
                } else {
                    val2Text = `${value02}`;
                }
            }
            if (img != undefined && object.$el.next('button').find('.ico-bank').length > 0) { // FETASK-1382 : 아이콘 나오게 추가 
                var classArr = object.$el.next('button').find('.ico-bank')[0].classList.value.split(' ');
                var className = 'logo';
                var className2 = 'ico-pb'; //CHPFMTASK-2128 클래스타입추가
                var className3 = 'img-feeling'; //CHPFMTASK-2128 클래스타입추가
                var className4 = 'ico-circle'; //CHPFMTASK-2128 클래스타입추가
                var className5 = 'bg'; //CHPFMTASK-2128 클래스타입추가
                var _idx ;

                // console.log('classArr',classArr)
                
                classArr.forEach((element, index) => {
                    if (element.startsWith(className) == true || element.startsWith(className2) == true || element.startsWith(className3) == true || element.startsWith(className4) == true || element.startsWith(className5) == true) { //CHPFMTASK-2128 클래스타입추가
                        _idx = index;
                    }
                    
                });
                // console.log('img',img)
                object.$el.next('button').find('.ico-bank').removeClass(classArr[_idx])
                //CHPFMTASK-2128 클래스타입추가
                if(object.$el.next('button').find('.ico-bank').hasClass('ico-circle-wrap')){
                    object.$el.next('button').find('.ico-bank').removeClass('ico-circle-wrap')
                }
                if(object.$el.next('button').find('.ico-bank').hasClass('bg-ter')){
                    object.$el.next('button').find('.ico-bank').removeClass('bg-ter')
                }
                object.$el.next('button').find('.ico-bank').addClass(img)
            }
            
        } else {
            object.$el.next('button').find('.txt-value01').text(`${value01}`).show();
            val2Text = `${value02}`;
        }

        if (value02 !== undefined || value02 !== '') {
            object.$el.next('button').find('.txt-value02').text(val2Text).show();
        } else {
            object.$el.next('button').find('.txt-value02').text('').hide();
        }
        // FETASK-860 태그
        // if (tag != undefined) {
        //     object.$el.next('button').find('.tag').show();
        //     object.$el.next('button').find('.tag .txt').text(tag);
        // } else {
        //     object.$el.next('button').find('.tag').hide();
        // }
    }

    // 뱅크형 (은행 아이콘)
    else {
        object.$el.next('button').find('.bank-box .txt-name').text(`${text}`);
        if (accountCheck === 'account') {
            if (value01 === undefined || value01 === '') {
                object.$el.next('button').find('.bank-box .txt-value01').text('').hide();
            } else {
                object.$el.next('button').find('.bank-box .txt-value01').text(`(${value01})`);
                object.$el.next('button').find('.bank-box .txt-value01').show();
            }
        } else {
            object.$el.next('button').find('.bank-box .txt-value01').text(`${value01}`);
        }
        object.$el.next('button').find('.bank-box .txt-value02').text(`${value02}`);
        object.$el.next('button').find('.ico-bank').removeClass().addClass(`ico-bank ${img} w20`);
    }
};
